<template>
  <div :class="['channels', { 'channels-selectable': selectable, 'channels-simple': simple }]">
    <template v-for="channel in channels">
      <div
        v-if="selectable || (!selectable && value[getField(channel.type)])"
        :key="channel.type"
        :class="['channels-item', { 'channels-item-unchecked': !value[getField(channel.type)] }]"
        v-on="selectable ? { click: () => itemClick(channel.type) } : {}"
      >
        <component v-if="channel.svg" :is="channel.svg" :style="{fontSize: size}" />
        <b-img v-else :src="getImageUrl(channel.icon)" :alt="channel.text" :style="{height: size}" />
        <div v-if="!simple" class="channels-item-text">
          {{ channel.text }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ChatIcon from '@/assets/images/channels/chat.svg'
import EmailIcon from '@/assets/images/channels/email.svg'
import InPersonIcon from '@/assets/images/channels/in-person.svg'
import PhoneIcon from '@/assets/images/channels/phone.svg'
import VideoIcon from '@/assets/images/channels/video.svg'
import SkypeIcon from '@/assets/images/channels/skype.svg'
import GoogleIcon from '@/assets/images/channels/google.svg'
import SlackIcon from '@/assets/images/channels/slack.svg'
import ZoomIcon from '@/assets/images/channels/zoom.svg'

export default {
  name: 'FavoriteChannels',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },

    size: {
      type: String,
      default: '1rem'
    },

    simple: {
      type: Boolean,
      default: false
    },

    selectable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      channels: [
        { type: 'Call', svg: PhoneIcon, text: 'Call' },
        { type: 'Email', svg: EmailIcon, text: 'Email' },
        { type: 'Talk', svg: InPersonIcon, text: 'In person' },
        { type: 'Text', svg: ChatIcon, text: 'Text' },
        { type: 'Video', svg: VideoIcon, text: 'Video' },
        { type: 'Hangout', svg: GoogleIcon, text: 'Hangout' },
        { type: 'Slack', svg: SlackIcon, text: 'Slack' },
        { type: 'Zoom', svg: ZoomIcon, text: 'Zoom' },
        { type: 'Skype', svg: SkypeIcon, text: 'Skype' }
      ]
    }
  },

  methods: {
    getField(type) {
      return `can${type}`
    },

    getImageUrl(image) {
      return require(`@/assets/images/channels/${image}`)
    },

    itemClick(type) {
      const field = this.getField(type)
      const value = { ...this.value, [field]: !this.value[field] }
      this.$emit('change', value)
    }
  }
}
</script>
